<script setup lang="ts">
import { RouterView } from 'vue-router'
import { initialize } from '@/apis/ApiInitializer'
import { useElementPlusLocale } from '@/locales/useElementPlusLocale'
import { useVcLocale } from '@/locales/useVcLocale'
import { useI18n } from 'vue-i18n'
import { ConfigProvider as VcConfigProvider } from '@vantis/components'
import { useAppContext } from '@/stores/appContext'
import axios from 'axios'
initialize();
const elementPlusLocale=useElementPlusLocale();
const vcLocale=useVcLocale();
const {t}=useI18n();
const hasPremission=(premissionCode:string,data:any)=>{
  if(premissionCode=="process.data.edit"){
    return Promise.resolve( data.owner.id==userId || userId?.split('|')[0] == "S");
  }
  return Promise.resolve(false);
}
const {userId,backendUrl}=useAppContext();

</script>

<template>
  <div class="app">
  <el-config-provider size="small" :locale="elementPlusLocale.locale">
    <vc-config-provider :locale="vcLocale.locale" :downBaseUrl="(backendUrl??'')" :hasPermission="hasPremission" :axios-instance="axios">
    <div class="router-view">
    <router-view></router-view>
      </div>
    </vc-config-provider>
  </el-config-provider>
  </div>
</template>

<style scoped lang="scss">
.app {
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}
.router-view{
  height: 100%;
}
</style>
